import styled from 'styled-components'
import React from 'react'
import { Link } from 'react-router-dom'


export const StyledLink = styled.a.attrs(props => ({
  className: props.className
}))`
  color: ${props => props.color ? props.color : '#375667'};
  text-decoration: underline !important;
  &:hover {
    cursor: pointer;
    color: ${props => props.theme.colors.primary};
  }
  &:active {
    color: ${props => props.theme.colors.primary};
  }
`
export const StyledNavigationLink = (props) => (<StyledLink as={Link} {...props}>{props.children}</StyledLink>)

